import type { components } from '@copilot/shared-types';
import { httpClient } from '../../shared/http/client';

export type MeetingDetail = components['schemas']['MeetingDetail'];
export type TranscriptSegment = components['schemas']['TranscriptSegmentPublic'];
export type Insight = components['schemas']['InsightPublic'];
export type Summary = components['schemas']['SummaryPublic'];

export async function getMeetingDetail(id: string): Promise<MeetingDetail> {
  const response = await httpClient.get<MeetingDetail>(`/api/v1/meetings/${id}`, {
    params: { include: 'transcript,insights,summary' },
  });
  return response.data;
}
